export type AdminMfaPhase = 'off' | 'grace' | 'enforce';

export function getMfaAdminRequiredFrom(): Date | null {
  const raw = process.env.REACT_APP_MFA_ADMIN_REQUIRED_FROM?.trim();
  if (!raw) return null;
  // Interpret as UTC midnight of YYYY-MM-DD
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!m) return null;
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 0, 0, 0));
}

export function getAdminMfaPhase(now: Date = new Date()): AdminMfaPhase {
  const requiredFrom = getMfaAdminRequiredFrom();
  if (!requiredFrom) return 'off';
  return now.getTime() >= requiredFrom.getTime() ? 'enforce' : 'grace';
}

export function formatMfaRequiredDate(): string {
  const d = getMfaAdminRequiredFrom();
  if (!d) return '';
  return d.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
